// Advisor Types - from signup process (source of truth)
export const ADVISOR_TYPES = [
  "Lawyer",
  "Commercial DD",
  "Financial DD",
  "Tech DD",
  "Tax DD",
  "Accountant",
  "Auditor",
  "Strategy Advisor",
  "M&A Advisor",
  "Other"
];

// Advisor Skills - from advisor company profile (expanded list, source of truth)
export const ADVISOR_SKILLS = [
  'Fundraising Strategy',
  'Pitch Deck Review',
  'Financial Modeling',
  'Due Diligence',
  'Term Sheet Negotiation',
  'Investor Relations',
  'M&A Advisory',
  'IPO Preparation',
  'Cap Table Management',
  'Legal Structuring',
  'Tax Planning',
  'Market Research',
  'Go-to-Market Strategy',
  'Product Strategy',
  'Technical Architecture',
  'Team Building',
  'Board Advisory'
];

// Industry Experience - from investor focus_areas (source of truth)
export const INDUSTRY_EXPERIENCE = [
  "AI",
  "Cloud/SaaS",
  "Climate",
  "Consumer",
  "Fintech",
  "Media",
  "Hardware",
  "Security",
  "Healthcare",
  "Services"
];
